<template>
    <section id="hero">
        <v-parallax dark src="http://file.sl.dande.online/static/landing/template/bghero1.jpg" height="750">
            <v-row align="center" justify="center">
                <v-col cols="10">
                    <v-row align="center" justify="center">
                        <v-col cols="12" md="7" xl="8">
                            <h1 class="display-2 mb-4"><strong>易座</strong>自习室无人值守自助预约入座通断电管理系统</h1>
                            <h1 class="font-weight-light">
                                无套路不加盟无负担，仅产生服务费* <br/>
                                扫码一站式使用自习室，无人值守，自助预约入座 <br/>
                                智能门、智能开关灯控通断电、美团验券、微信支付 <br/>
                                资金直接从微信、美团进入商家账户
                            </h1>
                            <h4 class="font-weight-light" style="margin-bottom: 20px;">
                                * 微信交易费、美团抽佣等相关第三方公司费用，不由本系统收取
                                <br>
                                * 灯控、门锁等硬件需另行购置
                            </h4>
                            <v-row justify="start" align="center" align-content="space-evenly">
                                <v-btn rounded
                                       outlined
                                       large
                                       dark
                                       @click="$vuetify.goTo('#download')"
                                       class="mt-5">
                                    自助入座示例
                                    <v-icon class="ml-2">mdi-arrow-down</v-icon>
                                </v-btn>

                                <!--                                // todo future 添加视频演示-->
                                <!--                                <div @click.stop="dialog = true" class="video d-flex align-center py-4 playBut"-->
                                <!--                                     style="margin: 20px 0 0 40px">-->
                                <!--                                    <a>-->
                                <!--                                        <svg version="1.1"-->
                                <!--                                             xmlns="http://www.w3.org/2000/svg"-->
                                <!--                                             xmlns:xlink="http://www.w3.org/1999/xlink"-->
                                <!--                                             xmlns:a="http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/"-->
                                <!--                                             x="0px"-->
                                <!--                                             y="0px"-->
                                <!--                                             width="60px"-->
                                <!--                                             height="60px"-->
                                <!--                                             viewBox="0 0 213.7 213.7"-->
                                <!--                                             enable-background="new 0 0 213.7 213.7"-->
                                <!--                                             xml:space="preserve">-->
                                <!--                    <polygon class="triangle"-->
                                <!--                            id="XMLID_18_"-->
                                <!--                            fill="none"-->
                                <!--                            stroke-width="7"-->
                                <!--                            stroke-linecap="round"-->
                                <!--                            stroke-linejoin="round"-->
                                <!--                            stroke-miterlimit="10"-->
                                <!--                            points="73.5,62.5 148.5,105.8 73.5,149.1 "/>-->

                                <!--                                            <circle-->
                                <!--                                                    class="circle"-->
                                <!--                                                    id="XMLID_17_"-->
                                <!--                                                    fill="none"-->
                                <!--                                                    stroke-width="7"-->
                                <!--                                                    stroke-linecap="round"-->
                                <!--                                                    stroke-linejoin="round"-->
                                <!--                                                    stroke-miterlimit="10"-->
                                <!--                                                    cx="106.8"-->
                                <!--                                                    cy="106.8"-->
                                <!--                                                    r="103.3"-->
                                <!--                                            />-->
                                <!--                  </svg>-->
                                <!--                                    </a>-->
                                <!--                                    <p class="subheading ml-2 mb-0">入门视频</p>-->
                                <!--                                </div>-->
                            </v-row>
                        </v-col>

                        <v-col cols="12" md="5" xl="4" class="hidden-sm-and-down">
                            <v-carousel continuous cycle hide-delimiters>
                                <v-carousel-item
                                        v-for="(carouselItem, index) in carouselItems"
                                        :key="'home-section_index-'+index"
                                >
                                    <v-img :src="carouselItem.src"
                                           aspect-ratio="1"
                                           style="align-self: center"
                                           contain>
                                    </v-img>
                                </v-carousel-item>
                            </v-carousel>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <div class="svg-border-waves text-white">
                <v-img src="@/assets/img/borderWaves.svg"/>
            </div>
        </v-parallax>
        <v-container fluid id="features" class="mt-2">
            <v-row align="center" justify="center">
                <v-col cols="10">
                    <v-row align="center" justify="space-around">
                        <!-- <v-col cols="12" class="text-center">
                          <h1 class="font-weight-light display-2">Title</h1>
                          <h1 class="font-weight-light">
                            Lorem ipsum dolor sit amet consectetur adipisicing elit.
                          </h1>
                        </v-col> -->
                        <v-col
                                cols="12"
                                sm="4"
                                class="text-center"
                                v-for="(feature, i) in features"
                                :key="i"
                        >
                            <v-hover v-slot:default="{ hover }">
                                <v-card class="card"
                                        shaped
                                        :elevation="hover ? 10 : 4"
                                        :class="{ up: hover }">
                                    <div class="card-icon">
                                        <!--                                        <v-img src="http://file.sl.dande.online/static/landing/template/icon-bg.png"-->
                                        <!--                                               max-width="100px"-->
                                        <!--                                               class="d-block ml-auto mr-auto"-->
                                        <!--                                               :class="{ 'zoom-efect': hover }"-->
                                        <!--                                                style="position: relative;">-->

                                        <!--                                        </v-img>-->

                                        <v-icon role="img" color="#283E79" size="500%" :class="{ 'zoom-efect': hover }"
                                                class="d-block ml-auto mr-auto card-icon-svg">{{feature.icon}}
                                        </v-icon>
                                    </div>
                                    <h1 class="font-weight-regular">{{ feature.title }}</h1>
                                    <h4 class="font-weight-regular subtitle-1">
                                        {{ feature.text }}
                                    </h4>
                                </v-card>
                            </v-hover>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>
        <v-dialog v-model="dialog" max-width="640px">
            <v-card>
                <youtube
                        :video-id="videoId"
                        @ready="ready"
                        @playing="playing"
                ></youtube>
            </v-card>
        </v-dialog>
        <div class="svg-border-waves">
            <img src="~@/assets/img/wave2.svg"/>
        </div>
    </section>
</template>

<script>
    export default {
        data() {
            return {
                dialog: false,
                videoId: "i8IvvHJssWE",
                carouselItems: [
                    {title: '订座', src: 'http://file.sl.dande.online/static/landing/1.jpg'},
                    {title: '购卡', src: 'http://file.sl.dande.online/static/landing/2.jpg'},
                    {title: '美团', src: 'http://file.sl.dande.online/static/landing/3.jpg'},
                    {title: '入座', src: 'http://file.sl.dande.online/static/landing/4.jpg'},
                    {title: '购买记录', src: 'http://file.sl.dande.online/static/landing/5.jpg'},
                    {title: '我的', src: 'http://file.sl.dande.online/static/landing/6.jpg'},
                    {title: '购买详情', src: 'http://file.sl.dande.online/static/landing/7.jpg'},
                ],
                features: [
                    {
                        icon: 'mdi-book',
                        title: "自助预约入座",
                        text: "有会员资格才能预约、下单以及入座",
                    },
                    {
                        icon: 'mdi-lamp',
                        title: "智能门 灯控",
                        text: "无人值守，顾客到店手机开门开灯",
                    },
                    {
                        icon: 'mdi-wechat',
                        title: "美团验券 微信支付",
                        text: "兼顾美团验券和微信支付等主流支付方式",
                    },
                ],
            };
        },
        watch: {
            dialog(value) {
                if (!value) {
                    this.pause();
                }
            },
        },
        methods: {
            ready(event) {
                this.player = event.target;
            },
            playing(event) {
                // The player is playing a video.
            },
            change() {
                // when you change the value, the player will also change.
                // If you would like to change `playerVars`, please change it before you change `videoId`.
                // If `playerVars.autoplay` is 1, `loadVideoById` will be called.
                // If `playerVars.autoplay` is 0, `cueVideoById` will be called.
                this.videoId = "another video id";
            },
            stop() {
                this.player.stopVideo();
            },
            pause() {
                this.player.pauseVideo();
            },
        },
    };
</script>

<style lang="scss">
    .circle {
        stroke: white;
        stroke-dasharray: 650;
        stroke-dashoffset: 650;
        -webkit-transition: all 0.5s ease-in-out;
        opacity: 0.3;
    }

    .playBut {
        /*  border: 1px solid red;*/
        display: inline-block;
        -webkit-transition: all 0.5s ease;
        cursor: pointer;

        .triangle {
            -webkit-transition: all 0.7s ease-in-out;
            stroke-dasharray: 240;
            stroke-dashoffset: 480;
            stroke: white;
            transform: translateY(0);
        }

        &:hover {
            .triangle {
                stroke-dashoffset: 0;
                opacity: 1;
                stroke: white;
                animation: nudge 0.7s ease-in-out;

                @keyframes nudge {
                    0% {
                        transform: translateX(0);
                    }
                    30% {
                        transform: translateX(-5px);
                    }
                    50% {
                        transform: translateX(5px);
                    }
                    70% {
                        transform: translateX(-2px);
                    }
                    100% {
                        transform: translateX(0);
                    }
                }
            }

            .circle {
                stroke-dashoffset: 0;
                opacity: 1;
            }
        }
    }
</style>

<style>
    .btn-play {
        transition: 0.2s;
    }

    .svg-border-waves .v-image {
        position: absolute;
        bottom: 0;
        left: 0;
        height: 3rem;
        width: 100%;
        overflow: hidden;
    }

    #hero {
        z-index: 0;
    }

    .svg-border-waves img {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        margin-bottom: -2px;
        z-index: -1;
    }

    .card {
        min-height: 300px;
        padding: 10px;
        transition: 0.5s ease-out;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        height: fit-content;
    }

    .card-icon {
        justify-self: center;
        align-self: center;
        width: 100px;
        height: 100px;
        position: relative !important;
        display: flex;
        align-items: center;
        justify-content: center;
        justify-items: center;
        flex-direction: row;
    }

    .card-icon-svg {
        /*position: absolute;*/
        /*left: 50% !important;*/
        /*top: 50% !important;*/
        max-width: 100px;
        /*transform: translate(-50%, -50%) !important;*/
    }

    .card .v-image {
        margin-bottom: 15px;
        transition: 0.75s;
    }

    .card h1 {
        margin-bottom: 10px;
    }

    .zoom-efect {
        transform: scale(1.1);
    }

    .up {
        transform: translateY(-20px);
        transition: 0.5s ease-out;
    }
</style>

<style>
    section {
        position: relative;
    }
</style>
